import { apiService as Service, appService } from '@/services/service'
import { Capacitor } from '@capacitor/core'

const url = 'oauth/token'

export const oauthService = {
	authenticate({ username, password }: Api.OauthAuthenticationInput) {
		const data: Api.OauthPostInput = {
			client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
			client_secret: import.meta.env.VITE_OAUTH_SECRET,
			grant_type: 'password',
			username,
			password,
		}

		return Capacitor.getPlatform() === 'web'
			? Service.post<Api.OauthResponse>({ url, data })
			: appService.post<Api.OauthResponse>({ url, data })
	},
	refresh({ refresh_token }: { refresh_token: string }) {
		const data: Api.OauthPostRefreshInput = {
			client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
			client_secret: import.meta.env.VITE_OAUTH_SECRET,
			grant_type: 'refresh_token',
			refresh_token,
		}
		return Service.post<Api.OauthResponse>({ url, data })
	},
	available: () =>
		Service.options({
			url: import.meta.env.VITE_API_BASEURL + url,
		}),
}

export default oauthService
